import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiConfigurationDetailContext } from '../api-configuration-detail-context';
import { ApiConfigurationWizardComponent } from '../api-configuration-wizard/api-configuration-wizard.component';
import { IRestApiConfiguration } from 'src/app/models/RestApiCaller/Interfaces/rest-api-configuration.interface';
import { RestApiConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-configuration';

@Component({
    selector: 'app-api-configurations-detail',
    templateUrl: './api-configurations-detail.component.html',
    styleUrls: ['./api-configurations-detail.component.scss'],
    imports: [ApiConfigurationWizardComponent]
})
export class ApiConfigurationDetailComponent implements OnInit {
    /**
     * Contexte du formulaire.
     */
    public _context: ApiConfigurationDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<ApiConfigurationDetailContext> = new BehaviorSubject(null);

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public apiConfigurationUpdated: EventEmitter<IRestApiConfiguration> = new EventEmitter();

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: ApiConfigurationDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    onApiConfigurationUpdated(apiConfiguration: RestApiConfiguration) {
        this.apiConfigurationUpdated.emit(apiConfiguration);
    }
}
